/* Important Info component for the ReplaceInfo */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";

const ReplaceInfo = () => {

  return (
    <div>
        <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
            <p className={`${styles.Red} text-center`}>REPLACING / REMOVING CREW</p>
            <hr className={`mt-2 mb-0`}/>
          <p className={`pt-3`}>CALLSHEET MAIN CREW MEMBERS</p>
          <p className={`pt-2`}><span className={`${styles.Red}`}>
            Replace:</span>
            </p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> In Manage Users delete the old Crew Member and Register the new one.</p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Replace the old Crew Member's details with the new one's in their Crew Info Department.
        </p>
        <p className={`pt-4`}>
          <span className={`${styles.Red}`}>Remove:</span></p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Delete the Crew Member in Manage Users.</p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Delete the Crew Member's details in their 
          Crew Info Department by deleting their info in the inputs boxes and 
          submitting the form.
        </p>
        <p className={`pt-5`}>NON-CALLSHEET EXTRA CREW MEMBERS</p>
        <p className={`pt-2`}>
          <span className={`${styles.Red}`}>Replace:</span></p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Delete the old Crew Member Position. </p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Create a new Position there with 
          the new Crew Member's details.
        </p>
        <p className={`pt-4`}>
           <span className={`${styles.Red}`}>Remove:</span></p>
          <p className={`pt-2`}>
          <span className={`${styles.Red}`}>*</span> Delete the Crew Member Position.</p>
          <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default ReplaceInfo